/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetUserSettingsResponse } from '../../models/get-user-settings-response';

export interface UserServiceGetUserSettings$Params {
  userUuid: string;
  discordId?: string;
}

export function userServiceGetUserSettings(http: HttpClient, rootUrl: string, params: UserServiceGetUserSettings$Params, context?: HttpContext): Observable<StrictHttpResponse<GetUserSettingsResponse>> {
  const rb = new RequestBuilder(rootUrl, userServiceGetUserSettings.PATH, 'get');
  if (params) {
    rb.path('userUuid', params.userUuid, {});
    rb.query('discordId', params.discordId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetUserSettingsResponse>;
    })
  );
}

userServiceGetUserSettings.PATH = '/api/v3/gateway/user/{userUuid}/settings';
